// extracted by mini-css-extract-plugin
export default {"wrapper":"popular_near_you__wrapper--ditT","loading":"popular_near_you__loading--9iWX","list":"popular_near_you__list--XmWe","item":"popular_near_you__item--h1h+"};